module.exports = __webpack_public_path__ + "media/images/amenities_icons/printer-b2615ac6d01aad24a61b3fdc71cfe8fa.svg";